import { IconPropsType } from '..';

export const AnonymousIcon = ({ ...props }: IconPropsType) => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M14.2149 7.96774V4.0946C14.2149 2.82869 13.1752 1.7998 11.896 1.7998H6.1095C4.83027 1.7998 3.79055 2.82869 3.79055 4.0946V7.96774C2.0214 8.38253 0.900024 9.00201 0.900024 9.69692C0.900024 10.909 4.30769 11.8894 8.59176 11.9486H9.00002C13.4964 11.9486 17.1 10.9359 17.1 9.69153C17.1 9.00201 15.9787 8.38253 14.2095 7.96774H14.2149Z"
      fill="#23252A"
    />
    <path
      d="M9.00547 14.6097C8.72241 14.642 8.48834 14.8036 8.36858 15.0407C8.12906 15.4662 7.65728 15.8559 7.21636 16.0498H7.20002C6.11676 16.4592 4.45467 15.8541 3.63813 14.8144C3.24075 14.3134 2.92503 13.7155 2.7345 13.0745L2.72362 13.0368C2.71273 13.0044 2.70729 12.9721 2.70729 12.9344C2.70729 12.7459 2.85971 12.595 3.04479 12.5843C3.31152 12.5681 3.6218 12.5627 3.93753 12.5627C4.86293 12.5627 5.76656 12.6381 6.64842 12.7782L6.55043 12.7674C7.90043 13.0799 8.50467 13.5377 9.00003 13.5377C9.49539 13.5377 10.1105 13.0799 11.4496 12.7674C12.2335 12.6381 13.1426 12.5681 14.068 12.5681C14.3837 12.5681 14.694 12.5789 15.0043 12.595H14.9607C15.1512 12.6004 15.3037 12.7566 15.3037 12.9452C15.3037 12.9775 15.3037 13.0152 15.2873 13.0422C15.0914 13.7209 14.7811 14.3134 14.3728 14.8306L14.3837 14.8198C13.5672 15.8595 11.6637 16.4969 10.5968 16.0606C10.145 15.8613 9.89277 15.4716 9.6587 15.0622V15.0514C9.52805 14.8144 9.28854 14.6474 9.00547 14.6205V14.6097Z"
      fill="#23252A"
    />
  </svg>
);
